import { resolveAfter } from "./resolve-after.mjs";
//#region src/async-utils/retry.ts
const retryUntilNoException = async (asyncFunction, { retries = 5, sleep = 100, onError = () => "retry", onRetry }) => {
	const sleepStrategy = typeof sleep === "number" ? () => sleep : sleep;
	for (let iteration = 1;; iteration++) try {
		return await asyncFunction(iteration);
	} catch (error) {
		if (onError(error, iteration) === "abort") throw error;
		if (iteration === retries) throw error;
		else {
			const delayMs = sleepStrategy(iteration);
			onRetry?.({
				attempt: iteration,
				delayMs,
				error
			});
			await resolveAfter(delayMs);
		}
	}
};
//#endregion
export { retryUntilNoException };
